export default __webpack_public_path__ + "content/media/3.92e5d55c.jpg";